<template>
  <standard-modal modal-name="CascoNoteModal" title="Примечание">
    <template v-slot:body>
      <div class="mb-5 text-gray-700">1) Страхователь даёт безусловное согласие АО «Страховая компания «Евразия», его аффилированным лицам и третьим лицам на сбор, хранение и обработку моих персональных данных или работников Страхователя - юридического лица, включая, но не ограничиваясь: ФИО, ИИН, гражданство, пол, дата и место рождения, место жительства, сведения документа, удостоверяющего личность, зафиксированные на электронном, бумажном и (или) ином материальном носителе, биометрические данные, в том числе на их трансграничную передачу в целях возникновения любых гражданско-правовых и (или) иных правоотношений, на весь период деятельности Страховщика. Страхователь подтверждает, что им получено согласие застрахованного, выгодоприобретателя на передачу его (их) персональных данных Страховщику и их дальнейшую обработку Страховщику, его аффилированным лицам и третьим лицам, в том числе на передачу и получение данных в/из единой страховой базы данных.</div>
      <div class="mb-5 text-gray-700">
        2) Страхователь подтверждает, что транспортные средства согласно приложению 1 к настоящему Заявлению:
        <ul>
          <li>являются предметом залога/лизинга;</li>
          <li>не имеют повреждения и дефекты; </li>
          <li>не эксплуатируется в спортивных состязаниях (авторалли, трофи рейды и тп.), в пробных пробегах используемый в тест драйвах; </li>
          <li>не эксплуатируется в миротворческих миссиях, в целях учебной езды; </li>
          <li>не принадлежит таксопаркам, а также не используется в качестве такси; </li>
          <li v-if="!(product === 15)">не используется автобусными парками, коммунальными службами, курьерскими службами;</li>
          <li>не имеют действующей страховой защиты в других страховых организациях;</li>
        </ul>
      </div>
      <div class="mb-5 text-gray-700">
        3) Страхователь подтверждает, что отсутствовали страховые случаи/убытки в течении предшествующих 3-х лет по рискам согласно настоящему Заявлению.
      </div>
    </template>
  </standard-modal>
</template>

<script>
import StandardModal from '@/components/Modals/Universal/StandardModal.vue';

export default {
  name: 'CascoNoteModal',
  components: {StandardModal},
  props: {
    product: null
  }
}
</script>

<style scoped>

</style>